

export default function LoadingSpinTrail() {
  return (
    <div className="flex justify-center items-center align-middle h-1/3 w-1/3">
      <div className="dot-spin"></div>
    </div>
  )
}